import React, { useEffect, useRef } from 'react';
import { Input, InputProps } from 'antd';

interface InputPlusProps extends InputProps {
  edited?: boolean;
  outline?: boolean;
}
/**
 * Extend the Input component
 * Feature:Support readonly status
 */
export default function InputPlus(props: InputPlusProps): JSX.Element {
  const { edited, autoFocus, outline, ...other } = props;
  const input = useRef(null);
  useEffect(() => {
    if (edited && autoFocus) {
      const textarea = input.current as any;
      textarea.focus();
    }
  }, [edited, autoFocus]);
  if (edited) {
    return (
      <Input
        ref={input}
        /* eslint-disable react/jsx-props-no-spreading */
        {...other}
      />
    );
  } else {
    return (
      <Input
        /* eslint-disable react/jsx-props-no-spreading */
        {...other}
        readOnly
        className={
          outline ? 'form-input-readonly-outline' : 'form-input-readonly'
        }
      />
    );
  }
}
InputPlus.defaultProps = {
  edited: undefined,
  outline: undefined,
};
